
export default class UnexpectedReponseError extends Error {
  constructor(operationId) {
    super(`Unexpected error response for ${operationId}`)
  }
}
